import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcoFormClearLink = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 10,
	height: 10,
	viewBox: "0 0 10 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M10 5C10 7.76142 7.76142 10 5 10C2.23858 10 0 7.76142 0 5C0 2.23858 2.23858 0 5 0C7.76142 0 10 2.23858 10 5ZM6.37493 2.44656C6.59189 2.2296 6.94365 2.2296 7.1606 2.44656L7.55344 2.8394C7.7704 3.05635 7.7704 3.40811 7.55344 3.62507L6.17851 5L7.55344 6.37493C7.7704 6.59189 7.7704 6.94365 7.55344 7.1606L7.1606 7.55344C6.94365 7.7704 6.59189 7.7704 6.37493 7.55344L5 6.17851L3.62507 7.55344C3.40811 7.7704 3.05635 7.7704 2.8394 7.55344L2.44656 7.1606C2.2296 6.94365 2.2296 6.59189 2.44656 6.37493L3.82149 5L2.44656 3.62507C2.2296 3.40811 2.2296 3.05635 2.44656 2.8394L2.8394 2.44656C3.05635 2.2296 3.40811 2.2296 3.62507 2.44656L5 3.82149L6.37493 2.44656Z"
	})]
});
const ForwardRef = forwardRef(SvgIcoFormClearLink);
export { ForwardRef as ReactComponent };
